// SCR-007's invoice-detail route (`/billing/:orgId/:period`, NAV-005). TASK-110 owns `/billing`
// (the periods list, screens/billing/index.ts) and deliberately leaves this path for this task,
// which composes TASK-110's `LedgerInvoice` panel with its own customer-invoice/statement panels.
import { defineRoute, type ScreenRoute } from "../../router/route";
import { CustomerInvoicePage } from "./customer-invoice";

export const routes: ScreenRoute[] = [
  defineRoute({
    nav: "NAV-005",
    path: "/customers/:orgId/invoices/:period",
    title: "Invoice",
    permission: "billing:read",
    component: CustomerInvoicePage,
  }),
];
